export class DraftManager {
    private static readonly STORAGE_KEY = 'bdEditorState';

    static loadDraft() {
        const savedState = localStorage.getItem(this.STORAGE_KEY);
        return savedState ? JSON.parse(savedState) : null;
    }

    static saveDraft(newState: any) {
        const currentState = this.loadDraft() || {};
        const updatedState = { ...currentState, ...newState };
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(updatedState));
    }

    static clearDraft() {
        localStorage.removeItem(this.STORAGE_KEY);
    }
}
